// Button Titles Enum (only for CustomButton usages)
// For i18n, use the translation key as the value

export const BUTTON_TITLES = {
  // Hardcoded titles
  REGENERATE_DESCRIPTION: 'Regenerate Description',
  BOOST_SEARCH: 'Boost Search',
  VIEW: 'View',
  SHOW_RESULTS: 'Show results',
  ADD_LISTING: 'Add listing',
  ONE_CLICK_MARKETING_MAGIC: '1-Click Marketing Magic',
  VIEW_LEADS: ' View Leads',
  BACK: 'Back',
  SEARCH: ' Search',
  ADD_LISTING_SEARCH: 'Add Listing',
  SUBMIT: 'Submit',
  CLOSE: 'Close',
  LOADING: 'Loading...',
  FIND_AGENT: 'Find Agent',
  VIEW_ALL: 'View All',
  SETUP_SHOP: 'Setup Shop',
  SETUP_SHOP_FREE: "Setup Shop- it's Free!",
  BOOST: 'Boost',
  CLEAR_ALL: 'Clear All', // t(TRANSLATIONS.TITLES.CLEAR_ALL)
  APPLY: 'Apply', // t(TRANSLATIONS.TITLES.APPLY)
  ADD_A_PROPERTY: 'Add a Property', // t(TRANSLATIONS.SUB_TITLES.ADD_A_PROPERTY)
  FIND_PROPERTY: 'Find Property', // t(TRANSLATIONS.TITLES.FIND_PROPERTY)
  GO_TO_MESSAGES: 'Go to Messages',
  MARK_AS_CLOSED: 'Mark as Closed', // t(TRANSLATIONS.TITLES.MARK_AS_CLOSED)
  VERIFY_NOW: 'Verify Now', // t(TRANSLATIONS.TITLES.VERIFY_NOW)
  RE_VERIFY_NOW: 'Re Verify Now', // t(TRANSLATIONS.TITLES.RE_VERIFY_NOW)
  PURCHASE: 'Purchase',
  FREE_TRIAL: 'Start Free Trial',
  STARTED_FREE_TRIAL: 'Continue with Premium',

  // Translation-based titles
  VIEW_PROFILE: 'View Profile', // t(TRANSLATIONS.TITLES.VIEW_PROFILE)
  VIEW_ALL_TRANSLATED: 'View All', // t(TRANSLATIONS.TITLES.VIEW_ALL)
  MESSAGE: 'Message', // t(TRANSLATIONS.TITLES.MESSAGE)
  EDIT_PROFILE: 'Edit Profile', // t(TRANSLATIONS.TITLES.EDIT_PROFILE)
  SHARE_PROFILE: 'Share Profile', // t(TRANSLATIONS.TITLES.SHARE_PROFILE)
  UNLOCK_TO_CHAT: 'Contact Agent', // t(TRANSLATIONS.TITLES.UNLOCK_TO_CHAT)

  // For iconOnly buttons (e.g. filter/search), use BUTTON_TITLES.ICON_ONLY
  ICON_ONLY: 'Icon_Only', // Placeholder for icon-only buttons, can be used for i18n keys if needed
};
